import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface RcmnOfSim {
	type: string;
	evCd: string;
	goodsCd: string;
	goodsType: string;
	evNm: string;
	evNightNm: string;
	freeYn: string;
	noTip: string;
	noShopping: string;
	noOption: string;
	startFix: string;
	rcmnScore: string;
	imageUrl: string;
	imageThum1: string;
	landing: string;
	outStartDt: string;
	adtPrice: string;
	outDeprtFg: string;
	outStartWday: string;
	outAirCompany: string;
	goodsBrandNm: string;
	outCityDiviNm: string;
	outAirCd: string;
	evProgDiviNm: string;
}

interface ExtChrusResponse {
	errorCode: string;
	errorMsg: string;
	crmRcmnSearchSimResultList: RcmnOfSim[];
}

const key = "useRcmnOfSimList";
/** ```
 * 추천상품 (braze)
 *   `/rcmn/getRcmnOfSimList`
 * ```*/
const getPath = (): string | null => `/bff/chorus/braze/rcmnOfSimList`;

/** ```
 * 추천상품 (braze)
 *   `/rcmn/getRcmnOfSimList`
 * ```*/
const useRcmnOfSimList = (evCd: string, options?: Partial<UseQueryOptions<ExtChrusResponse, Error>>) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () =>
			useConfigureAxios({
				url: getPath(),
				method: "POST",
				data: {evCd},
			}).then(r => {
				// TYPE_0 은 현재 상품과 동일, 그래서 제외
				const filteredList = ((r.data.crmRcmnSearchSimResultList as RcmnOfSim[]) ?? []).filter(
					v => v.type !== "TYPE_0",
				);
				return {...r.data, crmRcmnSearchSimResultList: filteredList};
			}),
		staleTime: 1000 * 30 * 60,
		throwOnError: true,
		...options,
	});

export default useRcmnOfSimList;
export {getPath, key};
export type {RcmnOfSim};
